export const SECTION_IDS = ["Introduction", "Projects", "Contact"];

export const RESUME_URL =
  "https://drive.google.com/file/d/1PwMGN6KOdKjpe4VzZHm-uvY_zk0xLKsX/view?usp=sharing";

export const CONTACT = {
  emails: ["saaketh1001@gmail.com", "ssodanapalli@umass.edu"],
  phone: "(720)-319-1842",
  linkedin: "https://www.linkedin.com/in/saaketh-sodanapalli-863a65228/",
  github: "https://github.com/Saaketh0",
  chess: "https://www.chess.com/member/saak_bb",
};
